const en = {
  nav: {
    dashboard: "Dashboard",
    produits: "Create a Product",
    stock: "Stock Status",
    fournisseurs: "Create a Supplier",
    bonsCommande: "Supply / Order",
    vendeurs: "Sellers/Touts",
    ventes: "Store Sales",
    commandes: "Online Sales",
    caisse: "Cash Register",
    rapports: "Reports",
    journalVentes: "Sales journal",
    parametres: "Settings",
    utilisateurs: "Users",
    activite: "Account Activity",
    abonnement: "My Subscription",
    monEntreprise: "My Business",
    devis: "Quotes",
    commandesClient: "Customer Orders",
    retoursClients: "Customer Returns",
    inventaires: "Inventory",
    reappro: "Restock",
    prix: "Prices & Promotions",
    taxes: "Taxes",
    deconnexion: "Logout",
  },
  auth: {
    connexion: "Sign In",
    email: "Email",
    motDePasse: "Password",
    seConnecter: "Sign In",
    deconnexion: "Logout",
    bienvenue: "Welcome",
    gestionCommerce: "Manage your business",
    identifiantsIncorrects: "Incorrect credentials",
    chargement: "Signing in...",
  },
  commun: {
    ajouter: "Add",
    modifier: "Edit",
    supprimer: "Delete",
    annuler: "Cancel",
    enregistrer: "Save",
    confirmer: "Confirm",
    rechercher: "Search",
    filtrer: "Filter",
    exporter: "Export",
    imprimer: "Print",
    fermer: "Close",
    oui: "Yes",
    non: "No",
    actif: "Active",
    inactif: "Inactive",
    total: "Total",
    date: "Date",
    statut: "Status",
    actions: "Actions",
    chargement: "Loading...",
    aucunResultat: "No results found",
    erreurServeur: "Server error, please try again",
    succes: "Operation successful",
    devise: "GNF",
    tous: "All",
  },
  dashboard: {
    titre: "Daily Dashboard",
    ventesMagasin: "Store sales",
    ventesVendeurs: "Sellers/Touts (field)",
    ventesLivraison: "Online Sales",
    totalEncaisse: "Total collected",
    beneficeBrut: "Gross profit",
    articlesVendus: "Items sold",
    commandesEnAttente: "Pending orders",
    ecartsVendeurs: "Seller/Tout discrepancies",
    clotureJournee: "Close the day",
    stockAlerte: "Stock alerts",
    vendeurActifs: "Active sellers today",
  },
  produits: {
    titre: "Product catalogue",
    ajouterProduit: "Add product",
    nom: "Product name",
    categorie: "Category",
    valise: "Suitcase",
    sac: "Bag",
    modele: "Model",
    taille: "Size",
    couleur: "Color",
    codeVariante: "Variant code",
    prixVenteMagasin: "Store price",
    prixVenteLivraison: "Delivery price",
    prixAchat: "Purchase price",
    description: "Description",
    photos: "Photos",
    variantes: "Variants",
    ajouterVariante: "Add variant",
    stockDisponible: "Available stock",
    stockFaible: "Low stock",
    rupture: "Out of stock",
  },
  stock: {
    titre: "Stock management",
    mouvements: "Stock movements",
    quantiteDisponible: "Available",
    quantiteReservee: "Reserved",
    seuilAlerte: "Alert threshold",
    alerteStock: "⚠️ Low stock",
    ajustement: "Manual adjustment",
    historique: "History",
    entree: "Entry",
    sortie: "Exit",
    canal: "Channel",
    magasin: "Store",
    terrain: "Field",
    livraison: "Delivery",
    approvisionnement: "Supply",
  },
  fournisseurs: {
    titre: "Suppliers",
    ajouterFournisseur: "Add supplier",
    nom: "Supplier name",
    telephone: "Phone",
    adresse: "Address",
    specialite: "Specialty",
    valises: "Suitcases",
    sacs: "Bags",
    mixte: "Mixed",
    approvisionnements: "Supplies",
    nouvelApprovisionnement: "New supply",
    coutTotal: "Total cost",
    comparerPrix: "Compare prices",
  },
  vendeurs: {
    titre: "Daily sellers",
    ajouterVendeur: "Add seller",
    sortieMatin: "Morning departure",
    retourSoir: "Evening return",
    articleConfies: "Items assigned",
    articlesRetournes: "Items returned",
    montantAttendu: "Expected amount",
    montantRemis: "Amount given",
    ecart: "Discrepancy",
    dette: "Debt",
    solde: "Debt balance",
    rembourser: "Record payment",
    bonSortie: "Departure slip",
    alerteEcart: "⚠️ Discrepancy detected",
    sortieDejaouverte: "This seller already has an open departure today",
  },
  ventes: {
    titre: "Store sales",
    nouvelleVente: "New sale",
    produitsVendus: "Items sold",
    modePaiement: "Payment method",
    especes: "Cash",
    orangeMoney: "Orange Money",
    mtnMoney: "MTN Money",
    autre: "Other",
    ticket: "Receipt",
    histoiqueVentes: "Sales history",
    venteDuJour: "Today's sales",
  },
  commandes: {
    titre: "Online orders",
    nouvelleCommande: "New order",
    client: "Customer",
    telephone: "Phone",
    adresseLivraison: "Delivery address",
    quartier: "Neighborhood",
    fraisLivraison: "Delivery fees",
    noteLivraison: "Delivery note (moto-taxi, etc.)",
    statut: {
      en_attente: "Pending",
      confirmee: "Confirmed",
      en_livraison: "Out for delivery",
      livree: "Delivered",
      annulee: "Cancelled",
    },
    changerStatut: "Change status",
    facture: "Delivery invoice",
  },
  caisse: {
    titre: "Cash register",
    solde: "Current balance",
    entrees: "Income",
    sorties: "Expenses",
    ajouterDepense: "Add expense",
    depenseDiverse: "Miscellaneous expense",
    description: "Description",
    montant: "Amount",
    filtrerParCanal: "Filter by channel",
    filtrerParDate: "Filter by date",
  },
  rapports: {
    titre: "Reports & Analytics",
    chiffreAffaires: "Revenue",
    beneficeNet: "Net profit",
    produitsLesPlusVendus: "Best selling products",
    performanceVendeurs: "Seller performance",
    comparaisonFournisseurs: "Supplier comparison",
    tauxLivraison: "Delivery rate",
    periode: "Period",
    exportPDF: "Export PDF",
    exportExcel: "Export Excel",
  },
  roles: {
    admin: "Admin",
    superadmin: "Super Admin",
    proprietaire: "Owner",
    gerant_vendeur: "Manager/Seller",
    employe: "Manager/Seller",
    vendeur: "Field seller",
    consultation: "Read-only",
  },
};

export default en;
